import { render, staticRenderFns } from "./PopularIcon.vue?vue&type=template&id=6c71ed59&"
import script from "./PopularIcon.vue?vue&type=script&lang=js&"
export * from "./PopularIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports